import {Component, EventEmitter, Output} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {StatementsService} from "../statements-service.service";

@Component({
  selector: 'app-trigger-statements',
  templateUrl: './trigger-statements.component.html',
  styleUrls: ['./trigger-statements.component.css']
})
export class TriggerStatementsComponent {

  myError: string;
  stop: string;
  result: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private statementsService: StatementsService) {
    this.myError = "";
    this.result = "";
  }

  ngOnInit() {
    this.statementsService.trigger(this).subscribe(result => {
      this.result = result.toString();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/trigger-statements/trigger-statements.component.ts